import { useState } from "react";
import { NavLink } from "react-router-dom";

import "../css/header.css";
import image1 from "../img/utpl.png";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="wrapper-header">
      <div className="max-w-6xl mx-auto px-6">
        <div className="logo">
          <NavLink to="/">
            <img src={image1} alt="utpl" className="logo" />
          </NavLink>
        </div>

        {/* BOTÓN HAMBURGUESA */}
        <div
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* MENÚ */}
        <div className={`menu-items ${menuOpen ? "open" : ""}`}>
          <a href="#inicio" onClick={() => setMenuOpen(false)}>Inicio</a>
          <a href="#objetivos" onClick={() => setMenuOpen(false)}>Objetivos</a>
          <a href="#actividades" onClick={() => setMenuOpen(false)}>Actividades</a>
          <a href="#lineas" onClick={() => setMenuOpen(false)}>Líneas temáticas</a>
          <a href="#agenda" onClick={() => setMenuOpen(false)}>Agenda</a>
        </div>
      </div>
    </div>
  );
}

export default Header;